"use strict";
exports.__esModule = true;
exports.formatVideoTime = void 0;
function formatVideoTime(seconds, guide) {
    if (seconds === void 0) { seconds = 0; }
    if (guide === void 0) { guide = seconds; }
    var s = Math.floor(seconds % 60);
    var m = Math.floor((seconds / 60) % 60);
    var h = Math.floor(seconds / 3600);
    var gm = Math.floor((guide / 60) % 60);
    var gh = Math.floor(guide / 3600);
    // handle invalid times
    if (isNaN(seconds) || seconds === Infinity) {
        // '-' is false for all relational operators (e.g. <, >=) so this setting
        // will add the minimum number of fields specified by the guide
        h = '-';
        m = '-';
        s = '-';
    }
    // Check if we need to show hours
    h = h > 0 || gh > 0 ? "".concat(h, ":") : '';
    // If hours are showing, we may need to add a leading zero.
    // Always show at least one digit of minutes.
    m = "".concat((h || gm >= 10) && m < 10 ? "0".concat(m) : m, ":");
    // Check if leading zero is need for seconds
    s = s < 10 ? "0".concat(s) : s;
    return h + m + s;
}
exports.formatVideoTime = formatVideoTime;
